import CrudPage from "@/components/admin/CrudPage";

const FIELDS = [
  { key: "question", label: "Question", span: "full" },
  { key: "answer", label: "Answer (highlight words to link an approved page)", type: "linktext", rows: 4, span: "full" },
  { key: "active", label: "Active", type: "checkbox" },
  { key: "sort_order", label: "Sort order", type: "number" },
];

const BLANK = {
  question: "", answer: "", active: true, sort_order: 99,
};

export default function AdminFaqs() {
  return (
    <CrudPage
      resource="faqs"
      title="FAQs"
      description="Public FAQ page pulls from this list."
      fields={FIELDS}
      blank={BLANK}
      testIdPrefix="faqs"
    />
  );
}
